/**
 * Build Accept request body.
 *
 * Confirmation soft-gate override must NEVER set forceAccept — that flag only
 * bypasses attachment unreadiness (`leads.intake.accept.requireAttachmentsReady`).
 *
 * @param {object} params
 * @param {boolean} [params.forceAttachmentOverride] — staff explicit attachment override
 * @param {boolean} [params.forceConfirmOverride] — FE soft-gate only; ignored for forceAccept
 * @param {object} [params.fields]
 * @param {string|null} [params.customerId]
 * @param {boolean} [params.awaitProviderPricing]
 */
export function buildAcceptRequestPayload({
  forceAttachmentOverride = false,
  forceConfirmOverride = false,
  fields,
  customerId,
  awaitProviderPricing,
} = {}) {
  void forceConfirmOverride; // soft-gate is FE-only; must not map to forceAccept
  return {
    forceAccept: Boolean(forceAttachmentOverride),
    ...(fields != null ? { fields } : {}),
    ...(customerId !== undefined ? { customerId } : {}),
    ...(typeof awaitProviderPricing === "boolean"
      ? { awaitProviderPricing }
      : {}),
  };
}
